import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';
import { LinkTo } from 'packages/kakapo-ui-kit/types/Link';
import treams from 'packages/kakapo-ui-kit/themes/treams';

const ClientLogo = styled(Link)`
	background-image: url('${(props) => props.theme.images.logo}?d=300x100/contain');
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	width: 100%;
	max-width: 100px;
	height: 50px;
	display: inline-block;
	vertical-align: top;

	@media screen and (min-width: ${Breakpoint.Medium}) {
		margin-right: 20px;
	}
`;

const PoweredByContainer = styled(Link)`
	display: inline-block;
	vertical-align: top;
	text-align: left;
	text-decoration: none;

	p {
		font-size: 10px;
		color: ${(props) => props.theme.colors.slateBlue};
		margin-bottom: 0;
	}

	@media screen and (max-width: 900px) {
		display: none;
	}
`;

const PoweredByLogo = styled.div`
	background-image: url(/images/treams-logo-black.svg);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	width: 100px;
	height: 40px;
	margin-top: -8px;
`;

export interface IProps {
	to: LinkTo;
}

export default function Logo({ to }: IProps) {
	return (
		<>
			<ClientLogo to={to} />

			{!treams.images.logo.endsWith('treams_logo.svg') && (
				<PoweredByContainer to={to}>
					<p>Empowered by</p>
					<PoweredByLogo />
				</PoweredByContainer>
			)}
		</>
	);
}
